<template>
  <div class="dict">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre"
            ><span></span>{{ this.$t('addInvoice.billInfo.title') }}</div
          >
        </template>
        <div class="collapse-content">
          <BillInfo
            v-bind:feeInfo="feeInfo"
            :companyList="companyList"
            :canEdit="canEdit"
            :fromContract="fromContract"
            @getCurrencyCode="getCurrencyCode"
            @selectCompany="selectCompany"
            @resetRowInfo="resetRowInfo"
            @changeCurrency="changeCurrency"
            @updatePayment="updatePayment"
            ref="feeInfo"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <el-tabs type="border-card" v-model="activeNameTab" class="addCooperationTabs">
          <el-tab-pane name="first" :label="$t('addInvoice.invoiceLine.title1')">
            <invoiceLine
              :departmentList="departmentList"
              :fromContract="fromContract"
              ref="invoiceLineInfo"
              :exchangeRate="feeInfo.exchangeRate"
              :feeInfo="feeInfo"
              :table="fundPayableInvoiceDetailList"
              @validate="invoiceLineValidate"
              @getTaxRateList="(list) => (this.taxRateList = list)"
              :canEdit="canEdit"
              @getDetail="getDetail"
              @calTotal="calTotal"
            />
          </el-tab-pane>
          <!-- <el-tab-pane name="voucherTab" :label="$t('addInvoice.invoiceLine.title2')">
            <voucher
              ref="voucher"
              :voucherList="voucherList"
              @reverseInfo="reverseInfo"
              @postInfo="postInfo"
              @doConfirmInfo="doConfirmInfo"
            ></voucher>
          </el-tab-pane>
          <el-tab-pane name="third" :label="$t('addInvoice.invoiceLine.title3')">
            <pay-info
              ref="invoiceLineInfo3"
              :canEdit="canEdit"
              :feeInfo="feeInfo"
              :canAdd="canAdd"
              :table="payList"
              :validate="invoiceLineValidate"
              @update="update"
            />
          </el-tab-pane> -->
        </el-tabs>
      </el-collapse-item>
    </el-collapse>
    <div class="fixed-bottom-btnList">
      <el-button
        v-hasPermi="['2021050810325930122']"
        :disabled="
          (['saved', 'withdraw', 'returned'].indexOf(feeInfo.payableInvoiceStatus) == -1 &&
            !canEdit) ||
          !feeInfo.payableInvoiceStatus
        "
        type="primary"
        @click="edit"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('addInvoice.btns.edit') }}
      </el-button>
      <el-button
        v-hasPermi="['2021050810332588509']"
        :disabled="
          ['', 'saved', 'withdraw', 'returned'].indexOf(feeInfo.payableInvoiceStatus) == -1 ||
          !canEdit
        "
        type="primary"
        @click="save"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('addInvoice.btns.save') }}
      </el-button>
      <el-button
        v-hasPermi="['2021050810334855363']"
        :disabled="
          ['', 'saved', 'withdraw', 'returned'].indexOf(feeInfo.payableInvoiceStatus) == -1
        "
        type="primary"
        @click="submit"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('addInvoice.btns.submission') }}
      </el-button>
      <!--<el-button
        v-hasPermi="['2021050810341172500']"
        :disabled="['submitted', 'hold'].indexOf(feeInfo.payableInvoiceStatus) == -1"
        type="primary"
        @click="doConfirm"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('functionBtn.confirm') }}
      </el-button>
       <el-button
        v-hasPermi="['2021050810343481971']"
        :disabled="
          ['confirmed'].indexOf(feeInfo.payableInvoiceStatus) == -1 ||
          ['notgenerate', 'generated', 'postError'].indexOf(feeInfo.postStatus) == -1
        "
        type="primary"
        @click="handleAccountEntry"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('addInvoice.btns.accountEntry') }}
      </el-button>
      <el-button
        v-hasPermi="['2021050810345588607']"
        :disabled="
          ['confirmed'].indexOf(feeInfo.payableInvoiceStatus) == -1 ||
          ['generated', 'postError'].indexOf(feeInfo.postStatus) == -1
        "
        type="primary"
        @click="doSyncVoucherForEntityData()"
        :loading="load"
        class="fixed-bottom-btn"
        >过账凭证
      </el-button>
      <el-button
        v-hasPermi="['2021050810351751907']"
        :disabled="['submitted', 'hold'].indexOf(feeInfo.payableInvoiceStatus) == -1"
        type="primary"
        @click="withdraw"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('addInvoice.btns.withdraw') }}
      </el-button>
      <el-button
        v-hasPermi="['2021050810353924582']"
        :disabled="['submitted', 'hold'].indexOf(feeInfo.payableInvoiceStatus) == -1"
        type="primary"
        @click="returnRecords"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('addInvoice.btns.return') }}
      </el-button>
      <el-button
        v-hasPermi="['2021050810360557842']"
        :disabled="
          ['submitted', 'released', 'confirmed'].indexOf(feeInfo.payableInvoiceStatus) == -1
        "
        type="primary"
        @click="generatePaymentDocument"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('addInvoice.btns.generatePaymentDocument') }}
      </el-button>

      <el-button
        v-hasPermi="['2021050810362519894']"
        :disabled="['saved', 'withdraw', 'returned'].indexOf(feeInfo.payableInvoiceStatus) == -1"
        type="primary"
        @click="deleteRecord"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('addInvoice.btns.delete') }}
      </el-button>
      <el-button
        v-hasPermi="['2021050810365142146']"
        :disabled="['confirmed'].indexOf(feeInfo.payableInvoiceStatus) == -1"
        type="primary"
        @click="doReverseAccountEntry()"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('functionBtn.writeOff') }}
      </el-button>

      <el-button
        type="primary"
        @click="print('busniessInbound')"
        class="fixed-bottom-btn"
        v-hasPermi="['2021111915082852138']"
        >打印业务入库单</el-button
      >
      <el-button
        type="primary"
        @click="print('invoice')"
        class="fixed-bottom-btn"
        v-hasPermi="['2021111915085541720']"
        >打印发票</el-button
      > -->
    </div>
    <print-dialog ref="printDialog"></print-dialog>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import BillInfo from './components/billInfo';
  //import payInfo from './components/payInfo';
  // import AccountingInfo from './components/accountingInfo';
  import invoiceLine from './components/invoiceLine';
  import DataBaseAPI from '@/api/dataBase';
  import API from '@/api/financeCenter/payables';
  import { delcommafy } from '@/common/js/util';
  import voucherMixins from '@/common/mixins/voucher.js';
  import printDialog from '@/components/Dialog/printDialog.vue';
  import XEUtils from 'xe-utils';
  export default {
    mixins: [voucherMixins],
    components: {
      BillInfo,
      // AccountingInfo,
      invoiceLine,
      //payInfo,
      printDialog,
    },
    name: 'baseEdit',
    data() {
      const date = XEUtils.toDateString(new Date(), 'yyyy-MM-dd');
      return {
        load: false,
        activeNames: ['1', '2'], //默认展开那些面板，
        orderInfo: {},
        feeInfo: {
          documentCode: '', // 单据编号
          payableInvoiceCompanyCode: '', // 公司编码
          payableInvoiceCompanyName: '', // 公司名称
          payableInvoiceCreateDate: date, // 制单日期
          payableInvoiceCreatePerson: '', // 制单人
          belongPeriod: date, // 归属日期
          invoiceUnitName: '', // 开票单位
          invoiceUnitNo: '', // 开票单位编码
          invoiceType: 'invoice', // 发票类型
          invoiceCode: '', // 发票编号
          invoiceNumber: '', // 发票张数
          currencyCode: '', // 币种
          exchangeType: '', // 汇率类型
          exchangeRate: '', // 汇率
          exchangeDate: date, // 汇率日期
          originalTotalAmount: '', // 发票原币总金额
          originalTotalWithoutTaxAmount: '', // 原币不含税总金额
          originalTaxAmount: '', // 原币税额
          domesticTotalAmount: '', // 本币总金额
          domesticTotalWithoutTaxAmount: '', // 本币不含税金额
          domesticTaxAmount: '', // 本币税额
          payableInvoiceStatus: '', // 单据状态
          mark: '', // 备注
          payableInvoiceCreatePersonName: '', //应付发票制单人名称
          payableInvoiceCreatePersonNos: [], //应付发票制单人编码，对应search
          payableInvoiceCreatePersonNo: '', //应付发票制单人编码
          isHnFlag: 'N',
        },
        fundPayableInvoiceDetailList: [],
        type: false,
        companyList: [], //公司列表
        departmentList: [], // 部门列表
        canAdd: true, //是否可以新增
        taxRateList: [], //率
        companyTree: [], // 部门数
        menuButtonList: [],
        payList: [], //付款信息
        defaultVisible: false, //匹配采购合同
        checkRowKeys: [],
        canEdit: this.$route.query.isEdit == 'Y',

        voucherFlag: 'AE_AP_INVOICES', //凭证标识
        //校验关联结算批次
        checkSettleParams: {
          associationType: 7,
          associationNoList: [],
        },
        fromContract: false, //表示从合同点击开票过来
      };
    },
    computed: {
      //搜索字段
      searchColumns() {
        const columns = [
          {
            type: 'searchTableSpec',
            name: this.$t('matchPurchaseContract.search.supplier'),
            prop: 'tenantCode',
            searchType: 'supplier',
          },
          {
            prop: 'contractNo',
            name: this.$t('matchPurchaseContract.search.contractNo'),
            type: 'input',
            placeholder: this.$t('matchPurchaseContract.search.contractNo'),
          },
          {
            prop: 'externalContractNo',
            name: this.$t('matchPurchaseContract.search.externalContractNo'),
            type: 'input',
            placeholder: this.$t(
              'matchPurchaseContract.search.externalPurchaseContractNoPlaceholder'
            ),
          },
          {
            prop: 'businessInboundDetailNo',
            name: this.$t('matchPurchaseContract.search.settleBatchNumber'),
            type: 'input',
            placeholder: this.$t('matchPurchaseContract.search.warehousingBatchNoPlaceholder'),
          },
          {
            prop: 'inboundDateStart',
            name: this.$t('matchPurchaseContract.search.warehousingDateStart'),
            type: 'startDaterangePicker',
          },
          {
            prop: 'inboundDateEnd',
            name: this.$t('matchPurchaseContract.search.warehousingDateEnd'),
            type: 'endDaterangePicker',
          },
        ];
        return columns;
      },
      //表格显示字段
      columnList() {
        return [
          {
            prop: 'contractNo',
            label: this.$t('matchPurchaseContract.table.contractNo'),
            width: 120,
          },
          {
            prop: 'contractDetailNo',
            label: this.$t('matchPurchaseContract.table.contractDetailNo'),
            width: 120,
          },
          {
            prop: 'businessInboundDetailNo',
            label: this.$t('matchPurchaseContract.table.businessInboundDetailNo'),
            width: 120,
          },
          {
            prop: 'inboundCreateDate',
            label: this.$t('matchPurchaseContract.table.inboundCreateDate'),
            width: 120,
          },
          {
            prop: 'productDesc',
            label: this.$t('matchPurchaseContract.table.productDesc'),
            width: 120,
          },
          {
            prop: 'productUnit',
            label: this.$t('matchPurchaseContract.table.productUnit'),
            width: 120,
          },
          {
            prop: 'inboundQuantity',
            label: this.$t('matchPurchaseContract.table.inboundQuantity'),
            width: 120,
          },
          {
            prop: 'inboundUnitPrice',
            label: this.$t('matchPurchaseContract.table.inboundUnitPrice'),
            width: 120,
          },
          {
            prop: 'matchedQuantity',
            label: this.$t('matchPurchaseContract.table.matchedQuantity'),
            width: 120,
          },
          {
            prop: 'matchedAavailableQuantity',
            label: this.$t('matchPurchaseContract.table.matchedAavailableQuantity'),
            width: 120,
          },
          {
            prop: 'matchInboundQuantity',
            label: this.$t('matchPurchaseContract.table.matchInboundQuantity'),
            width: 120,
          },
          {
            prop: 'overShippedQuantity',
            label: this.$t('matchPurchaseContract.table.overShippedQuantity'),
            width: 120,
          },
          {
            prop: 'invoiceQuantity',
            label: this.$t('matchPurchaseContract.table.invoiceQuantity'),
            width: 120,
          },
          {
            prop: 'invoiceUnitPrice',
            label: this.$t('matchPurchaseContract.table.invoiceUnitPrice'),
            width: 120,
          },
          {
            prop: 'originalTotalWithoutTaxAmount',
            label: this.$t('matchPurchaseContract.table.originalTotalWithoutTaxAmount'),
            width: 120,
          },
          { prop: 'taxRate', label: this.$t('matchPurchaseContract.table.taxRate'), width: 120 },
          {
            prop: 'taxAmount',
            label: this.$t('matchPurchaseContract.table.taxAmount'),
            width: 120,
          },
          {
            prop: 'totalAmount',
            label: this.$t('matchPurchaseContract.table.totalAmount'),
            width: 120,
          },
        ];
      },
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
    },
    mounted() {
      //制单人默认
      this.feeInfo.payableInvoiceCreatePersonName = this.userInfo.userName;
      this.feeInfo.payableInvoiceCreatePersonNos = [this.userInfo.userCode];
      this.feeInfo.payableInvoiceCreatePersonNo = this.userInfo.userCode;
      this.feeInfo.payableInvoiceCreatePerson = [
        {
          personNo: this.feeInfo.payableInvoiceCreatePersonNo,
          personName: this.feeInfo.payableInvoiceCreatePersonName,
        },
      ];
      this.getCompany();
      this.$nextTick(() => {
        this.getButtonList();
      });
      this.fundPayableInvoiceDetailList.forEach((item) => {
        item.exchangeRate = this.feeInfo.exchangeRate;
      });
      // this.feeInfoList = JSON.parse(JSON.stringify(this.feeInfo)).fundPayableInvoiceDetailList
      if (this.$route.query.id) {
        this.getDetail();
        this.getPaymentList();
      } else if (this.$route.query.contractNo) {
        // 通过合同创建发票
        this.fromContract = true;
        this.createByContract();
      }
    },
    methods: {
      // 确认
      doConfirmInfo(info) {
        let params = { id: this.feeInfo.id, invoiceCode: this.feeInfo.invoiceCode, ...info };
        this.loading.startLoading();
        this.$axios.post(API.DO_CONFIRM, params).then((res) => {
          this.loading.endLoading();
          if (res.data.code === 0) {
            this.$message({
              showClose: true,
              message: this.$t('message.success'),
              type: 'success',
            });
            this.getDetail();
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      //获取发票详情
      getDetail() {
        this.$axios.get(`${API.GET_DETAIL_API}/${this.$route.query.id}`).then((res) => {
          if (0 == res.data.code) {
            this.feeInfo = res.data.data;
            this.fundPayableInvoiceDetailList = this.feeInfo.fundPayableInvoiceDetailList;

            // 获取凭证ID 获取凭证列表
            this.entityDataId = this.feeInfo.id;
            this.checkSettleParams.associationNoList = [this.feeInfo.id];
            this.getAccountEntry();
            this.getLastDepart(this.feeInfo.payableInvoiceCompanyCode);

            this.$nextTick(() => {
              this.$refs.invoiceLineInfo.checkDifferenceInvoice();
            });
          }
        });
      },

      // 通过合同创建发票
      createByContract() {
        let params = { purchaseContractNo: this.$route.query.contractNo };
        this.$axios.post(`${API.CREATE_BY_CONTRACT}`, params).then((res) => {
          if (0 == res.data.code) {
            this.feeInfo = res.data.data;
            this.feeInfo.exchangeDate = this.feeInfo.belongPeriod;
            this.feeInfo.payableInvoiceStatus = '';
            this.fundPayableInvoiceDetailList = this.feeInfo.fundPayableInvoiceDetailList;
            this.getLastDepart(this.feeInfo.payableInvoiceCompanyCode);
            this.$nextTick(() => {
              this.$refs.feeInfo.selectTaxRate();
            });
          }
        });
      },

      // 获取付款信息列表
      getPaymentList() {
        this.$axios
          .get(API.PAYABLE_INVOICE_PAYMENT_LIST, { invoiceId: this.$route.query.id })
          .then((res) => {
            if (res.data.code === 0) {
              res.data.data.forEach((i) => {
                i.lineNumberList = [{ label: i.paymentLineNumber, value: i.paymentLineId }];
              });
              this.payList = res.data.data.slice(0);
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          });
      },

      //默认币种
      getCurrencyCode(val) {
        this.feeInfo.currencyCode = val;
      },
      //获取公司信息
      async getCompany() {
        let params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
        };
        const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
        if (selectStatus.data.code == 0) {
          this.companyList = selectStatus.data.data.personCompanyInfo;
        }
      },
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
        });
      },
      // 选择公司
      async selectCompany(v) {
        this.resetRowInfo();
        this.getLastDepart(v);

        // 切换到海宁
        let res = await this.$baseRequest.getSysConfigByCompany({
          code: 'PAYABLE_INVOICE_HN',
          companyCode: v,
        });
        this.feeInfo.isHnFlag = res;
      },
      // 改变币种
      changeCurrency() {
        let fulldata = this.$refs.invoiceLineInfo.$refs.xTable.getTableData().fullData;
        if (
          fulldata &&
          fulldata[0] &&
          (fulldata[0].expenseGroup == 'COST' || fulldata[0].expenseGroup == 'COST-CON')
        ) {
          this.resetRowInfo();
        }
      },
      // 重置行信息
      resetRowInfo() {
        this.fundPayableInvoiceDetailList = [];
      },

      // 取一级部门的最后一级部门
      async getLastDepart(v) {
        console.log(33);
        this.departmentList = [];
        let params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
          personCompanyCode: v,
        };
        const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
        if (selectStatus.data.code == 0) {
          this.departmentList = selectStatus.data.data.personDepartmentInfo;
          console.log(this.departmentList);
        }
      },
      // 打印
      print(flag) {
        let obj = {};
        let isHnFlag = this.feeInfo.isHnFlag == 'Y';
        if (flag == 'busniessInbound') {
          obj.moduleCode = isHnFlag ? 'hnBusinessInbound' : 'businessInbound';
          obj.templateCode = isHnFlag ? 'hnBusinessInboundPrint' : 'businessInboundPrint';
          obj.printUrl = API.BATCH_PRINTBUSINESSINBOUND;
          obj.dataNoList = [this.feeInfo.id];
        } else if (flag == 'invoice') {
          obj.moduleCode = 'hnPayableInvoice';
          obj.templateCode = 'hnPayableInvoicePrint';
          obj.printUrl = API.EXPORT_PRINT;
          obj.dataNo = this.feeInfo.id;
        }
        this.$refs.printDialog.openDialog(true, obj);
      },
      // 判断行操作可否进行
      invoiceLineValidate() {
        const feeInfo = this.$refs.feeInfo.getVal();
        if (feeInfo) {
          this.canAdd = true;
        } else {
          this.canAdd = false;
          this.$message({
            showClose: true,
            message: this.$t('addInvoice.warnInfo.infoInfo'),
            type: 'error',
          });
        }
        return this.canAdd;
      },
      // 更新发票头部信息
      /* updateBillInfo:vm.$utils.debounce(function(obj){
      this.feeInfo = {
        ...this.feeInfo,
        ...obj
      };
      // JSON.parse(JSON.stringify(Object.assign(this.feeInfo, obj)))
    },500), */
      // 首页统计合计
      calTotal: XEUtils.debounce(function (data) {
        if (data) {
          let total = this.$refs.invoiceLineInfo.calTotal();
          XEUtils.objectEach(total, (item, key) => {
            // 对象迭代器，只能用于遍历对象，性能高于 each
            this.feeInfo[key] = item;
          });
        }
      }, 500),
      // 更新付款信息
      update() {
        this.payInfoList = [];
      },
      // 更新付款信息
      updatePayment: XEUtils.debounce(function (feeInfo) {
        this.feeInfo = feeInfo;
      }, 500),
      // 提交
      submit() {
        this.loading.startLoading();
        // 判断是否为差额发票
        // 【ID1002539】 发票区分差额发票 如果有采购货款并且可匹配数量为0的 则认定为差额发票。所有行也必须为采购货款且可匹配数量为0
        let diffInvoice = this.$refs.invoiceLineInfo.checkDifferenceInvoice();
        let footerData = this.$refs.invoiceLineInfo.totalObj;
        if (diffInvoice && footerData.invoiceQuantity != 0) {
          this.$message({
            showClose: true,
            type: 'error',
            message:
              '差额发票规则：如果行信息中存在费用类型为采购货款且本次匹配入库数量为0的数据，则所有行均需满足此条件！',
          });
          return;
        }
        this.toleranceCheck().then((res) => {
          this.loading.endLoading();
          if (!res) return;
          const { result, fundPayableInvoice } = res;
          if (!result) {
            this.$confirmAction(
              this.$t('addInvoice.confirm.toleranceCheck.title'),
              this.$t('addInvoice.confirm.toleranceCheck.content')
            )
              .then(() => {
                this.confirmSubmit(fundPayableInvoice);
              })
              .catch(() => {
                this.$message({
                  showClose: true,
                  type: 'info',
                  message: this.$t('confirm.deleteCancelled'),
                });
              });
          } else {
            this.confirmSubmit(fundPayableInvoice);
          }
        });
      },
      confirmSubmit(fundPayableInvoice, cancelValidate) {
        this.loading.startLoading();
        if (
          fundPayableInvoice.invoiceType == 'creditMemo' &&
          this.feeInfo.originalTotalAmount >= 0
        ) {
          this.loading.endLoading();
          this.$message({
            showClose: true,
            message: this.$t('addInvoice.warnInfo.needLowZero'),
            type: 'error',
          });
          return;
        } else if (
          fundPayableInvoice.invoiceType == 'invoice' &&
          this.feeInfo.originalTotalAmount <= 0
        ) {
          this.loading.endLoading();
          this.$message({
            showClose: true,
            message: this.$t('addInvoice.warnInfo.needOverZero'),
            type: 'error',
          });
          return;
        }
        let params = {
          ...fundPayableInvoice,
          saveUpdate: 2,
          id: fundPayableInvoice.id,
          version: fundPayableInvoice.version,
          lastModifiedBy: this.userInfo.userCode,
          cancelValidate,
        };
        params = this.$baseRequest.assignObj(params);
        params.fundPayableInvoiceDetailList = params.fundPayableInvoiceDetailList.map((item) => {
          item = this.$baseRequest.assignObj(item);
          return item;
        });
        this.loading.startLoading();
        this.$axios.post(API.SUBMIT_Invoice, params).then((res) => {
          this.loading.endLoading();
          if (res.data.code === 0) {
            this.$message({
              showClose: true,
              message: this.$t('message.success'),
              type: 'success',
            });
            if (this.fromContract) {
              this.backContract();
            } else {
              this.goBack();
            }
          } else if (res.data.code === 10) {
            this.$reportErrors({
              msg: res.data.msg,
              code: res.data.code,
              callback: () => {
                //确认提交，cancelValidate传值true取消校验
                this.confirmSubmit(fundPayableInvoice, true);
              },
            });
          } else {
            this.loading.endLoading();
            if (res.data.data) {
              this.getDetail(res.data.data.id);
            }
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      // 保存
      save(type) {
        this.loading.startLoading();
        // 判断是否为差额发票
        // 【ID1002539】 发票区分差额发票 如果有采购货款并且可匹配数量为0的 则认定为差额发票。所有行也必须为采购货款且可匹配数量为0
        let diffInvoice = this.$refs.invoiceLineInfo.checkDifferenceInvoice();
        let footerData = this.$refs.invoiceLineInfo.totalObj;
        if (diffInvoice && footerData.invoiceQuantity != 0) {
          this.$message({
            showClose: true,
            type: 'error',
            message:
              '差额发票规则：如果行信息中存在费用类型为采购货款且本次匹配入库数量为0的数据，则所有行均需满足此条件！',
          });
          return;
        }

        this.toleranceCheck('save').then((res) => {
          this.loading.endLoading();
          if (!res) return;
          const { result, fundPayableInvoice } = res;
          if (!result) {
            this.$confirmAction(
              this.$t('addInvoice.confirm.toleranceCheck.title'),
              this.$t('addInvoice.confirm.toleranceCheck.content')
            )
              .then(() => {
                this.confirmSave(fundPayableInvoice, type);
              })
              .catch(() => {
                this.$message({
                  showClose: true,
                  type: 'info',
                  message: this.$t('confirm.deleteCancelled'),
                });
              });
          } else {
            this.confirmSave(fundPayableInvoice, type);
          }
        });
      },
      confirmSave(fundPayableInvoice) {
        this.loading.startLoading();
        if (
          fundPayableInvoice.invoiceType == 'creditMemo' &&
          this.feeInfo.originalTotalAmount >= 0
        ) {
          this.loading.endLoading();
          this.$message({
            showClose: true,
            message: this.$t('addInvoice.warnInfo.needLowZero'),
            type: 'error',
          });
          return;
        } else if (
          fundPayableInvoice.invoiceType == 'invoice' &&
          this.feeInfo.originalTotalAmount <= 0
        ) {
          this.loading.endLoading();
          this.$message({
            showClose: true,
            message: this.$t('addInvoice.warnInfo.needOverZero'),
            type: 'error',
          });
          return;
        }
        let params = {
          ...fundPayableInvoice,
          saveUpdate: 1,
          changePayableInvoiceCompanyCode: false,
        };
        params = this.$baseRequest.assignObj(params);
        params.fundPayableInvoiceDetailList = params.fundPayableInvoiceDetailList.map((item) => {
          item = this.$baseRequest.assignObj(item);
          return item;
        });
        this.loading.startLoading();
        this.$axios.post(API.CREATE_PAYABLE_INVOICE, params).then((res) => {
          this.loading.endLoading();
          if (res.data.code === 0) {
            this.$message({
              showClose: true,
              message: this.$t('message.success'),
              type: 'success',
            });
            this.feeInfo = res.data.data;
            this.fundPayableInvoiceDetailList = this.feeInfo.fundPayableInvoiceDetailList;
            // this.goBack()
          } else {
            this.loading.endLoading();
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      // 编辑
      edit() {
        this.canEdit = true;
      },
      // 删除
      deleteRecord() {
        this.$confirmAction()
          .then(() => {
            this.loading.startLoading();
            this.$axios.post(API.DELETE_INVOICE, { idList: [this.feeInfo.id] }).then((res) => {
              this.loading.endLoading();
              if (res.data.code === 0) {
                this.$message({
                  showClose: true,
                  message: this.$t('message.success'),
                  type: 'success',
                });
                this.goBack();
              } else {
                this.$message({ showClose: true, message: res.data.msg, type: 'error' });
              }
            });
          })
          .catch(() => {
            this.loading.endLoading();
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      // 撤回 只有已提交、暂挂状态下才能点击该按钮
      withdraw() {
        let params = {
          //撤回所需参数
          id: this.feeInfo.id,
          //检查关联结算批次所需参数
          ...this.checkSettleParams,
        };
        this.$baseRequest
          .doWithdrawCommon(API.WITHDRAW_INVOICE, params)
          .then(() => {
            this.getDetail();
          })
          .catch((e) => {
            console.log(e);
          });
      },
      // 退回 只有“已提交”、“暂挂”状态下的数据才能点击退回按钮 权限划分：财务人员按钮
      returnRecords() {
        this.$confirmAction(
          this.$t('addInvoice.confirm.withdraw.title'),
          this.$t('addInvoice.confirm.withdraw.content')
        )
          .then(() => {
            this.loading.startLoading();
            this.$axios.post(API.RETURNED_INVOICE, { id: this.feeInfo.id }).then((res) => {
              this.loading.endLoading();
              if (res.data.code === 0) {
                this.$message({
                  showClose: true,
                  message: this.$t('message.success'),
                  type: 'success',
                });
                this.goBack();
              } else {
                this.$message({ showClose: true, message: res.data.msg, type: 'error' });
              }
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      generatePaymentDocument() {
        this.loading.startLoading();
        this.$axios.post(API.CHECK_CREATE_PAYMENTAPPLY, { id: this.feeInfo.id }).then((res) => {
          this.loading.endLoading();
          if (res.data.code === 0) {
            let path = {
              path: '/payment/paymentApplyAdd',
              name: 'paymentApplyAdd',
              meta: {
                title: '付款申请单创建',
              },
              query: {
                sourceType: 'INVOICE',
                id: this.feeInfo.id,
                isEdit: 'Y',
              },
            };
            this.$store.dispatch('tagsView/addTabView', path).then(() => {
              this.$nextTick(() => {
                this.$router.push(path);
              });
            });
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
              duration: 8000,
            });
          }
        });
      },
      // 允差校验
      async toleranceCheck(flag) {
        let feeInfo = this.$refs.feeInfo.getVal();
        let invoiceLineList = await this.$refs.invoiceLineInfo.getVal();
        let costFlag = true; //保证成本类型的必须匹配合同
        // let [...invoiceLineInfo] = invoiceLineList;//深拷贝
        let invoiceLineInfo = XEUtils.clone(invoiceLineList);
        if (!invoiceLineInfo[0]) invoiceLineInfo = false;
        if (feeInfo && invoiceLineInfo) {
          invoiceLineInfo.map((item, index) => {
            item.domesticTaxAmount = delcommafy(item.domesticTaxAmount);
            item.domesticTotalWithoutTaxAmount = delcommafy(item.domesticTotalWithoutTaxAmount);
            item.domesticTotalAmount = delcommafy(item.domesticTotalAmount);
            item.payableInvoiceDetailNo = index + 1;
            item = this.$baseRequest.assignObj(item);
            if (item.expenseGroup == 'COST' || item.expenseGroup == 'COST-CON') {
              if (!item.inboundCode) costFlag = false;
            }
            return item;
          });
        } else if (!feeInfo) {
          this.loading.endLoading();
          this.$message({
            showClose: true,
            message: this.$t('addInvoice.warnInfo.infoInfo'),
            type: 'error',
          });
          return false;
        } else if (!invoiceLineInfo) {
          this.loading.endLoading();
          if (!invoiceLineList) {
            //必填校验为空 直接提示
            //必填校验不成功
            this.$message({
              showClose: true,
              message: this.$t('发票行信息不能为空'),
              type: 'error',
            });
            return false;
          } else {
            this.loading.endLoading();
            if (!invoiceLineList[0] && flag !== 'save') {
              //行信息为空并且不是保存
              this.$message({
                showClose: true,
                message: this.$t('发票行信息不能为空'),
                type: 'error',
              });
              return false;
            }
          }
        }
        if (!costFlag && flag !== 'save') {
          this.loading.endLoading();
          this.$message({
            showClose: true,
            message: '费用大类为成本或委托加工的行信息必须匹配采购合同',
            type: 'error',
          });
          return false;
        }
        // let feeInfo = this.feeInfo
        if (!invoiceLineInfo && flag == 'save') invoiceLineInfo = [];
        return this.$axios.post(API.TOLERANCE_CHECK, invoiceLineInfo).then((res) => {
          const payableInvoiceCreatePerson =
            feeInfo.payableInvoiceCreatePerson && feeInfo.payableInvoiceCreatePerson[0];
          let fundPayableInvoice = {
            ...feeInfo,
            payableInvoiceCreatePersonName: payableInvoiceCreatePerson
              ? payableInvoiceCreatePerson.personName
              : feeInfo.payableInvoiceCreatePersonName,
            payableInvoiceCreatePersonNo: payableInvoiceCreatePerson
              ? payableInvoiceCreatePerson.personNo
              : feeInfo.payableInvoiceCreatePersonNo,
            fundPayableInvoiceDetailList: invoiceLineInfo,
          };
          fundPayableInvoice = this.$baseRequest.assignObj(fundPayableInvoice);
          delete fundPayableInvoice.payableInvoiceCreatePerson;
          if (res.data.code === 0) {
            return { result: res.data.data, fundPayableInvoice };
          } else {
            this.loading.endLoading();
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      // 返回
      goBack() {
        let pathList = {
          fromPath: {
            path: this.$route.path,
            name: this.$route.name,
            meta: {
              keepAlive: true,
              title: this.$t('currenciesAndCalendar.addCurrencies.addCurrencies'),
            },
          },
          toPath: {
            path: '/payables/billList',
            name: 'payablesBillList',
            meta: {
              keepAlive: false,
              title: this.$t('currenciesAndCalendar.addCurrencies.queryCurrencies'),
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', pathList).then(() => {
          this.$nextTick(() => {
            this.$router.push(pathList.toPath);
          });
        });
      },
      // 返回合同
      backContract() {
        let pathList = {
          fromPath: {
            path: this.$route.path,
            name: this.$route.name,
            meta: {
              keepAlive: true,
              title: this.$t('currenciesAndCalendar.addCurrencies.addCurrencies'),
            },
          },
          toPath: {
            path: '/salePurchaseHN/singlePurchaseContractEdit',
            name: 'singlePurchaseContractEditHN',
            meta: {
              keepAlive: false,
              title: '采购合同修改',
            },
            query: {
              id: this.$route.query.contractId,
              type: 'HT03',
              contractNo: this.$route.query.contractNo,
              isEdit: true,
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', pathList).then(() => {
          this.$nextTick(() => {
            this.$router.push(pathList.toPath);
          });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .deliveryOrderTop {
    background-color: #fff;
    margin-bottom: 10px;
    padding: 26px 10px 11px 10px;
  }
</style>
